import React from "react";
import MagnifyingGlass from "../../common/icons/MagnifyingGlass";
import CloseIcon from "../../common/icons/CloseIcon";

const SearchBar = ({ onChangeHandler, searchPhrase, onErase }) => (
  <div className="tw-flex">
    <div className="tw-py-2 tw-relative">
      <input
        value={searchPhrase}
        onChange={onChangeHandler}
        type="text"
        className="tw-inline-flex tw-justify-center tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-shadow-sm tw-px-4 tw-py-2 tw-bg-white tw-text-sm tw-font-medium tw-text-gray-700 tw-hover:bg-gray-50 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-offset-2 tw-focus:ring-offset-gray-100 tw-focus:ring-indigo-500"
        placeholder="Search..."
      />
      <div className="tw-absolute tw-top-5 tw-right-3">
        {searchPhrase ? (
          <span onClick={onErase}>
            <CloseIcon className="tw-z-20" />
          </span>
        ) : (
          <span>
            <MagnifyingGlass className="tw-z-20" />
          </span>
        )}
      </div>
    </div>
  </div>
);

export default SearchBar;
